<template>
<div>
  <el-col :span="14" class="form-container">
    <el-col :span="24" class="card-header" style="text-align: center;">
      <a href="https://www.smartcharts.net/" class="smartchart-logo"><object data="https://login.smartcharts.xyz/img/logo.svg" type="image/svg+xml"></object></a>
    </el-col>
    <el-form ref="ruleForm" :model="ruleForm" label-width="120px">

      <el-col :span="24" class="form-container_">
        <h1>Welcome Back</h1>
        <p style="  font-size: 18px;font-weight: 500;">Hello {{ my_name }}, where would you like to go next?</p>

      </el-col>

      <el-col :span="24" style="text-align: center; margin-top: 20px; padding-top: 40px; float: none;">
        <el-col :span="24" style="text-align: center;  float: none;">
          <el-button size="large" @click="handleLogout('ruleForm')" type="success">LOGOUT</el-button>
          <el-button size="large" @click="handleProceed('ruleForm')" type="success">PROCEED TO SMART CHARTS</el-button>

        </el-col>

      </el-col>
    </el-form>

  </el-col>

</div>
</template>

<script>
export default {
  name: 'DataComponent',
  props: {
    data: {
      type: Object
    },
    broker_list: {
      type: Array
    },
    session_token_url: {
      type: String
    }
  },
  data() {
    return {
      key: '',
      my_name: '',
      ruleForm: {},
      radio1: '',
      char_length: false,
      char_number: false,
      char_capital: false,
      char_symbol: false,
      password_score: 0,
      broker_list_: [],
      active_lang: 'en'

    }
  },
  created() {

  },
  mounted() {
    if (this.data) {
      this.populateData()
    }
  },
  methods: {
    test() {
      var axios = require('axios');
          axios.post(
          'https://api.myaccount.tinkerpub.com/api/user?code=z0JYDq96dMAZNl7ats0Rd3egZ98Nzi2nM3M33Um36QChZ2lswDWVY0VZG67F6TmHg01jFpZPKoDtu3exThzcWDEPFYKWytDXusls',
          {}, // Request body (empty in this case)
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            withCredentials: true
          }
        )
        .then(response => {
          console.log('User data:', response.data);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
    handleProceed() {
      // console.log('https://sc2-uat.fxbluelabs.com/?token=' + localStorage.getItem('token') + '&session_token_url=' + encodeURIComponent(this.session_token_url))
  

      if(localStorage.getItem('go_to_app_url')) {
        let url = localStorage.getItem('go_to_app_url')    
        window.location.href =  url + '/?token=' + localStorage.getItem('token') + '&session_token_url=' + encodeURIComponent(this.session_token_url)
      } else {
        console.log('no url found')
      }
      
      
    },
    handleChooseBrooker(brooker) {
      let broker_list = this.broker_list
      broker_list.forEach((item, index) => {
        item.status = 'Active'
        console.log(index)
        if (item.id === brooker.id) {
          item.status = 'selected'
          this.ruleForm['broker'] = item
        }
      })
      this.broker_list_ = broker_list
    },
    populateData() {
      this.ruleForm = this.data
      this.broker_list_ = this.broker_list
      if (sessionStorage.getItem('session_email')) {
        this.my_name = sessionStorage.getItem('session_email')
      }
    },
    handleLogout() {
      sessionStorage.clear()
      localStorage.clear()
      this.$emit('logout');

    },
    checkInputLength() {
      this.password_score = 0
      if (this.ruleForm.pass.length > 8) {
        this.char_length = true;
        this.password_score = this.password_score + 1
      } else {
        this.char_length = false;
        if (this.password_score > 1) {
          this.password_score = this.password_score - 1
        }

      }

      const hasNumber = /\d/;
      if (hasNumber.test(this.ruleForm.pass)) {
        this.char_number = true;
        this.password_score = this.password_score + 1
      } else {
        this.char_number = false;
        if (this.password_score > 1) {
          this.password_score = this.password_score - 1
        }
      }

      const hasCapitalLetter = /[A-Z]/;
      if (hasCapitalLetter.test(this.ruleForm.pass)) {
        this.char_capital = true
        this.password_score = this.password_score + 1
      } else {
        this.char_capital = false
        if (this.password_score > 1) {
          this.password_score = this.password_score - 1
        }
      }

      const hasSymbol = /[^a-zA-Z0-9]/;
      if (hasSymbol.test(this.ruleForm.pass)) {
        this.char_symbol = true
        this.password_score = this.password_score + 1
      } else {
        this.char_symbol = false
        if (this.password_score > 1) {
          this.password_score = this.password_score - 1
        }
      }
    }
  },
}
</script>

<style scoped>
span.el-radio-button__inner {
  color: #a2b0d5 !important;
  border: 1px solid #7e85aa !important;
  background-color: transparent !important;
}

.form-container {
  /* padding: 40px; */

  float: none;
}

.el-radio-button__inner {
  color: #a2b0d5 !important;
  border: 1px solid #7e85aa !important;
  background-color: transparent !important;

}

label.el-radio-button.is-active {
  background-color: #ffffff2b;
}

.steps {
  height: 5px;
  border-radius: 10px;
  background-color: transparent;
  border: 1px solid #ffffff59;
  margin-right: 5px;
  width: 32% !important;
}

.green_ {
  background-color: #a4f14a;
  color: #a4f14a;
}

.red_ {
  background-color: #ff6c6c;
  color: #ff6c6c;
}

.yellow_ {

  background-color: #ffd077;
  color: #ffd077;
}

.green_text {
  color: #a4f14a;
}

.form-container[data-v-7cb4def3] {
  /* padding: 40px; */

  margin-bottom: 40px;
}

.main-container {
  float: none !important;
  margin: 0 auto !important;
  color: #ffffff !important;
  padding-top: 10vh;
}

.broker-list-wrapper {
  text-align: left;
}

.broker-list-wrapper h2 {
  font-weight: 300;
  font-size: 22px;
  margin-top: 40px;
  margin-bottom: 20px;
}

.broker-list-item {
  /* background-color: #3c4f6d; */
  transition: box-shadow 0.3s ease;
  background: linear-gradient(to right, #3f4f75, #3f3b5e);
  padding: 20px;
  display: flex;
  border-radius: 5px;
  height: 30px;
}

.logo_container img {
  /* width: 60px; */
  margin-left: 40px;
  width: auto;
  height: 30px;
}

.logo_container {}

.part-2 p,
.part-3 p,
.part-divider p {
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
  padding-top: 5px;
}

.part-2 p {
  color: #ffffff80;
}

.part-2 p strong {
  color: #ffffff;
}

.part-divider {
  text-align: center;
  color: #ffffff3d;
}

.broker-list-item.active {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-icon {
  transform: rotate(180deg) !important;
  color: #ffffff80;
  font-size: 20px;
  margin-left: 20px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  float: left;
  margin-top: 10px;
  margin-right: 5px;
}

.green {
  background-color: #93ca85;
}

.yellow {
  background-color: #e2ca5d;
}

.broker-list-item {
  margin-bottom: 10px;
}

.part-4 {
  float: right;
  text-align: center;

}

.broker-list-item:hover {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-btn {
  float: right;
  text-align: center;
  box-shadow: inset 0px 0px 0px 1px #93ca85;
  padding: 5px 40px;
  border-radius: 3px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.item-btn:hover {
  background-color: #93ca855c;
  transition: background-color 0.3s ease;
}

.darkBlue {
  background: #283a5d !important;
  width: 13%;
  margin-right: 5px;
  display: inline-block;
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.available-types-title {
  text-align: center;
  color: #ffffffb3;
}

.available-icon-true {
  border-radius: 50%;
  /* background-color: #93ca85; */
  background-color: #5a954b;
  padding: 3px;
}

.available-icon-false {
  border-radius: 50%;
  /* background-color: #ea7374; */
  background-color: #e44f51;
  font-weight: bold;
  padding: 3px;
}

.item-btn.btn-apply {
  padding: 5px 24px;
}

.available-item-check-container {
  border-right: 1px solid #ffffff3d;
  margin-top: 5px;
}

.available-item-check-container.end {
  border-right: none !important;
}

.page-subtitle {
  color: #adc0ff;
  font-size: 20px;
}

.logo-icon-container {
  margin-left: -10px;
  display: flex;
  align-items: center;
  align-content: center;
  margin-top: -5px;
}

.available-broker-wrapper {
  padding-bottom: 10vh;
}

.available-broker-wrapper h2 {
  margin-bottom: 0px !important;
}

.broker-item-list {
  box-shadow: 1px 2px 3px #00000021;

}

.form-container_ {
  float: none;
  text-align: center;
}

form.el-form {
  margin-top: 0px;
}
</style>
